import { domGetOffsetTop } from 'pf-frontend-common/src/helper/dom/get-offset-top';
import { StatsAttributionService } from 'pf-frontend-common/src/service/stats-attribution/service';
import { StatsContexterService } from 'pf-frontend-common/src/service/stats-contexter/service';
import { StatsDataService } from 'pf-frontend-common/src/service/stats-data/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { BrokerStatsDataAdapterFactory } from 'common/data/broker/stats/data-adapter.factory';
import { ContentGroupViewFactory } from 'common/module/content-group/view.factory';
import { DomCallRevealButtonFactory } from 'common/module/dom/call-reveal-button.factory';
import { TextTrimViewFactory } from 'common/module/text-trim/view.factory';
import { StatsService } from 'common/service/stats/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { BrokerPageView } from 'desktop/module/broker/page/view';
import { LeadEmailFormBrokerFactory } from 'desktop/module/lead/email/form/broker.factory';

export function BrokerPageViewFactory(): BrokerPageView {
  return new BrokerPageView(
    ContentGroupViewFactory(),
    DomCallRevealButtonFactory(),
    TextTrimViewFactory(),
    LeadEmailFormBrokerFactory(),
    StatsService(),
    StatsContexterService(),
    StatsDataService(),
    StatsAttributionService(),
    StatsTealiumProviderService(),
    BrokerStatsDataAdapterFactory(),
    WindowService(),
    WindowLocationService(),
    domGetOffsetTop
  );
}
